import { effect, signal } from "@preact/signals";
import { type Resolution, audioID, error, fps, resolution, videoID } from "./config";

const resolutionToPixel = (r: Resolution): [number, number] => {
    switch (r) {
        case "4k":
            return [3840, 2160];
        case "1440p":
            return [2560, 1440];
        case "720p":
            return [1280, 720];
        default:
            return [1920, 1080];
    }
};

const stream = signal<MediaStream | null>(null);

effect(() => {
    (async () => {
        const [width, height] = resolutionToPixel(resolution.value);
        const constraints: MediaStreamConstraints & {
            audio: MediaTrackConstraints;
            video: MediaTrackConstraints;
        } = {
            audio: {
                noiseSuppression: false,
                autoGainControl: false,
                echoCancellation: false,
                channelCount: { ideal: 2 },
            },
            video: {
                width: { ideal: width },
                height: { ideal: height },
                frameRate: { ideal: fps.value },
            },
        };

        if (videoID.value) {
            constraints.video.deviceId = videoID.value;
        }

        if (audioID.value) {
            constraints.audio.deviceId = audioID.value;
        }

        try {
            stream.value = await navigator.mediaDevices.getUserMedia(constraints);
        } catch (err: unknown) {
            error.value = err;
        }
    })();

    return () => {
        if (stream.value) {
            for (const track of stream.value.getTracks()) {
                track.stop();
            }
        }
    };
});

export { stream };
